
import React, { Component } from "react";
import PageTitle from "../Components/Theme/PageTitle/index.js";
import DashboardLayout from "../Components/Theme/DashboardLayout/index.js";
import { Button, Col, Modal, Table, Row, message } from "antd";
import { InfoCard } from "../Components/Theme/Cards/index.js";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Spinner from '../Components/Theme/Spinner/index.js';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js'
dayjs.extend(utc);
import * as WrappedSelectLiveScheduleForm from '../Components/Schedule/SelectLiveScheduleForm.js';
import * as WrappedDetailedScheduleForm from '../Components/Schedule/DetailedSchedule/DetailedScheduleForm.js';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import * as liveScheduleActions from '../redux/actions/liveScheduleActions.js';
import * as selectedResourceCollectionActions from '../redux/actions/selectedResourceCollectionActions.js';
import * as postedScheduleActions from '../redux/actions/postedScheduleActions.js';
import AuthLogic from '../AuthLogic/index.js';
import getOffsetTime from '../utils/getOffsetTime.js';
import { Divider, Space } from 'antd';

export class SchedulesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            liveScheduleModal: false,
            liveScheduleSearch: false,
            liveSchedules: [],
            liveSchedulesTable: {
                columns: [
                    {
                        title: 'Live Schedules',
                        dataIndex: 'name',
                        render: text => <a>{text}</a>
                    }
                ],
                data: ''
            },
            selectedLiveSchedule: this.props.selectedLiveSchedule,
            scheduleDate: dayjs().startOf('day'), // api won't work unless start date is at beginning of day

            detailedScheduleModal: false,
            detailedStartDate: dayjs().startOf('day').subtract(7, 'day'),
            detailedEndDate: dayjs().endOf('day'),
            timeOffset: getOffsetTime(dayjs()),
            showFilteredResources: false,
            filteredLiveSchedulesData: []
        };
        this.handleClick = this.handleClick.bind(this);
    }

    async componentDidMount() {
        try {
            if (!this.props.user) {
                return;
            }
            await this.props.actions.fetchListOfResourceCollection(this.props.user.login.id)
        } catch (error) {
            alert("Loading list of resource collections failed\n" + JSON.stringify(error));
            throw Error(error);
        }
        if (!localStorage.getItem('selectedLiveSchedule')) {
            this.props.actions.fetchFindResourceCollection();
        } else {
            const record = JSON.parse(localStorage.getItem('selectedLiveSchedule'));
            this.props.actions.updateResourceCollectionSelected(record);
            this.setState({ selectedLiveSchedule: record, })
        }

        // populate local liveSchedulesTable from schedules' list in redux
        const data = [];
        if (this.props.liveSchedules) {
            const liveSchedulesTable = this.state.liveSchedulesTable;
            for (let schedule of this.props.liveSchedules) {
                const row = {
                    key: schedule.id,
                    id: schedule.id,
                    name: schedule.name,
                };
                data.push(row);
            }
            liveSchedulesTable.data = data;
            this.setState({
                liveSchedulesTable
            });
        }
    }

    handleLiveScheduleSubmit = () => {
        if (this.state.selectedLiveSchedule.name && this.state.scheduleDate) {
            let state = {
                startDate: dayjs(this.state.scheduleDate.format("YYYY-MM-DD")),
                scheduleFormat: 1,
                resourceCollectionName: this.state.selectedLiveSchedule.name,
                resourceCollectionId: this.state.selectedLiveSchedule.id,
                editMode: this.editMode,
            };

            this.props.navigate('/live-schedule-view-short', { state: state });
        } else {
            // alert("Attempted to submit without selecting a Schedule or Schedule Date");
        }
    };

    handleDetailedScheduleSubmit = () => {
        if (this.state.detailedStartDate && this.state.detailedEndDate) {
            let state = {
                schedule: this.state.selectedLiveSchedule,
                detailedStartDate: this.state.detailedStartDate.format("YYYY-MM-DD HH:mm:ss"),
                detailedEndDate: this.state.detailedEndDate.format("YYYY-MM-DD HH:mm:ss"),
            }
            this.props.navigate('/detailed-schedule-view', { state: state });

        } else {
            alert("Attempted to submit without choosing Start Date or End Date");
        }
    };

    showLiveModal = () => {
        this.setState({
            liveScheduleModal: true,
        });
    };


    showDetailedModal = () => {
        this.setState({
            detailedScheduleModal: true,
        });
    };

    handleLiveModalCancel = (e) => {
        this.setState({
            liveScheduleModal: false
        });
    };

    handleDetailedModalCancel = (e) => {
        this.setState({
            detailedScheduleModal: false
        });
    };

    handleLiveScheduleSearch = () => {
        if (this.state.liveScheduleSearch === false) {
            this.setState({
                liveScheduleSearch: true
            });
        } else {
            this.setState({
                liveScheduleSearch: false
            });
        }
    };

    handleLiveScheduleSelect = (record) => {
        this.setState({
            selectedLiveSchedule: record,
            liveScheduleSearch: false,
            showFilteredResources: false
        }, () => {
            localStorage.setItem('selectedLiveSchedule', JSON.stringify(this.state.selectedLiveSchedule));
        });
        this.props.actions.updateResourceCollectionSelected(record);
    };

    handleDateChange = date => {
        if (!date) {
            return null;
        }

        date = date.startOf('day'); // makes sure we're sending it the beginning of the day
        this.setState({
            scheduleDate: date || dayjs().startOf('day') // prevent null on field clear
        });
    };

    handleDetailedStartDateChange = date => {
        const prevDate = this.state.detailedStartDate;
        if (date && date.isAfter(dayjs())) {
            message.config({
                top: 24,
                duration: 2.5,
                maxCount: 5,
            });
            message.error('Start date cannot exceed the current time');
            date = null;
        }
        if (date && date.isAfter(dayjs(this.state.detailedEndDate))) {
            message.config({
                top: 24,
                duration: 2.5,
                maxCount: 5,
            });
            message.error('End date cannot precede the start date');
            date = null;
        }
        this.setState({
            detailedStartDate: date || prevDate
        });
    };

    handleDetailedEndDateChange = date => {
        const prevDate = this.state.detailedEndDate;
        if (date && date.isAfter(dayjs().endOf('day'))) {
            message.config({
                top: 24,
                duration: 2.5,
                maxCount: 5,
            });
            message.error('End date cannot exceed the current time');
            date = null;
        }
        if (date && date.isBefore(dayjs(this.state.detailedStartDate))) {
            message.config({
                top: 24,
                duration: 2.5,
                maxCount: 5,
            });
            message.error('End date cannot precede the start date');
            date = null;
        }
        this.setState({
            detailedEndDate: date || prevDate
        });
    };

    convertDateToDetailedFormat(date) {
        let newDate = date.replace(/-/g, '')
        newDate = newDate.substr(0, newDate.indexOf('T'));
        return newDate;
    }

    // In to disable redirects for sections that aren't in phase 1
    handleClick = e => {
        e.preventDefault();
    }

    handleSearchChange = async searchValue => {

        if (searchValue && searchValue !== '') {
            this.setState({ showFilteredResources: true });
        } else this.setState({ showFilteredResources: false });

        let filteredArray = [];

        if (this.state.liveSchedulesTable && this.state.liveSchedulesTable.data) {
            filteredArray = await this.state.liveSchedulesTable.data.filter((value) => {
                // QA - #1830 - Search box issue resolved --> some dummy accounts have null values in the array that comes back
                if (value && value.name && value.name.toLowerCase().includes(searchValue.toLowerCase())) {
                    return value;
                }
                return null;
            });
        }

        this.setState({
            filteredLiveSchedulesData: filteredArray
        });
    }

    render() {

        if (this.props.user.securityLevels) {
            return (
                <DashboardLayout>
                    <PageTitle title={'View Schedules'}
                        subTitle={''} />


                    <Row gutter={32}>

                        {AuthLogic.postedSchedules(this.props.user) &&
                            (
                                <Col lg={8} md={24} xs={18}>
                                    <Link to="/posted-schedules">
                                        <InfoCard value={'Posted Schedules'} /></Link>
                                </Col>
                            )
                        }


                        {AuthLogic.liveSchedules(this.props.user) &&
                            (
                                <Col lg={8} md={24} xs={18}
                                    onMouseDown={this.showLiveModal}
                                >
                                    <Link to="#">
                                        <InfoCard value={'Live Schedules'} />
                                    </Link>

                                    <Modal
                                        open={this.state.liveScheduleModal}
                                        title="Select Live Schedule"
                                        zIndex={2000}
                                        onCancel={this.handleLiveModalCancel}
                                        footer={[
                                            // <Button key="back" onClick={this.handleLiveModalCancel}>Cancel</Button>,
                                            // <Button key="submit" type="submit" onClick={this.handleLiveScheduleSubmit}>
                                            //     Submit
                                            // </Button>
                                        ]}
                                    >

                                        <WrappedSelectLiveScheduleForm.default
                                            handleLiveScheduleSearch={this.handleLiveScheduleSearch}
                                            liveScheduleSearch={this.state.liveScheduleSearch}
                                            liveSchedules={this.props.liveSchedules}
                                            selectedLiveSchedule={this.state.selectedLiveSchedule}
                                            scheduleDate={this.state.scheduleDate}
                                            handleLiveDateChange={this.handleDateChange}
                                            returnSearchValue={this.handleSearchChange}
                                            handleLiveScheduleSubmit={this.handleLiveScheduleSubmit}
                                            columns={this.state.liveSchedulesTable.columns}
                                            dataSource={!this.state.showFilteredResources ?
                                                this.state.liveSchedulesTable.data :
                                                this.state.filteredLiveSchedulesData}
                                            handleLiveScheduleSelect={this.handleLiveScheduleSelect}
                                        />

                                    </Modal>
                                </Col>
                            )
                        }

                        {AuthLogic.assignments(this.props.user) &&
                            (
                                <Col lg={8} md={24} xs={18}
                                    onMouseDown={this.showDetailedModal}
                                >
                                    <Link to="#" onClick={this.handleClick} >

                                        <InfoCard value={'Details for Tours/Assignments/Day Types'} />
                                    </Link>

                                    <Modal
                                        open={this.state.detailedScheduleModal}
                                        title="Select dates for Detailed Schedule"
                                        zIndex={2000}
                                        onCancel={this.handleDetailedModalCancel}
                                        footer={[
                                            <Divider />,
                                            <Space size={"large"}>
                                                <Button key="back" onClick={this.handleDetailedModalCancel} color="danger" variant="solid">Cancel</Button>
                                                <Button key="submit" onClick={this.handleDetailedScheduleSubmit} color="primary" variant="solid">
                                                    Submit
                                                </Button>
                                            </Space>
                                        ]}
                                    >
                                        <Divider />
                                        <WrappedDetailedScheduleForm.default
                                            scheduleDate={this.state.scheduleDate}
                                            handleStartDateChange={this.handleDetailedStartDateChange}
                                            handleEndDateChange={this.handleDetailedEndDateChange}
                                            detailedStartDate={this.state.detailedStartDate}
                                            detailedEndDate={this.state.detailedEndDate}
                                            selectedLiveSchedule={this.state.selectedLiveSchedule}
                                        />
                                    </Modal>

                                </Col>
                            )
                        }
                    </Row>

                </DashboardLayout>
            )
        } else return <Spinner />
    }
}

SchedulesPage.propTypes = {
    user: PropTypes.object.isRequired,
    liveSchedules: PropTypes.array
};

function mapStateToProps(state) {
    return {
        user: state.user,
        liveSchedules: state.listResourceCollections.resources,
        selectedLiveSchedule: state.selectedResourceCollection
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            fetchListOfResourceCollection: bindActionCreators(
                liveScheduleActions.fetchListOfResourceCollection,
                dispatch
            ),
            fetchFindResourceCollection: bindActionCreators(
                selectedResourceCollectionActions.fetchFindResourceCollection,
                dispatch
            ),
            updateResourceCollectionSelected: bindActionCreators(
                selectedResourceCollectionActions.updateResourceCollectionSelected,
                dispatch
            ),
        }
    };
}

export const withRouter = (Component) => {
    const Wrapper = (props) => {
        const navigate = useNavigate();
        const location = useLocation();

        return <Component navigate={navigate} {...props} location={location} />;
    };
    return Wrapper;
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(SchedulesPage));
